(function () {
  'use strict';

  var EMOJIS = ['\uD83C\uDDE8\uD83C\uDDF4', '\uD83C\uDFC6', '\u26BD'];
  var WEIGHTS = [0.45, 0.25, 0.30];

  var state = {
    root: null,
    mouse: { x: -9999, y: -9999, active: false },
    particles: [],
    width: 0,
    height: 0,
    rafId: null,
    lastTime: 0,
    running: false,
    reducedMotion: false,
    booted: false
  };

  function pickEmoji() {
    var r = Math.random();
    var acc = 0;
    for (var i = 0; i < WEIGHTS.length; i++) {
      acc += WEIGHTS[i];
      if (r <= acc) return EMOJIS[i];
    }
    return EMOJIS[EMOJIS.length - 1];
  }

  function particleLimit() {
    var w = window.innerWidth;
    if (state.reducedMotion) {
      return w < 768 ? 8 : 12;
    }
    if (w < 480) return 18;
    if (w < 768) return 28;
    if (w < 1200) return 40;
    return 55;
  }

  function setStatus(running, reason) {
    state.running = running;
    if (!window.MundialParticles) return;
    window.MundialParticles.running = running;
    window.MundialParticles.blockedReason = reason || null;
    window.MundialParticles.particleCount = state.particles.length;
  }

  function ensureRoot() {
    if (!document.body) return null;

    var root = document.getElementById('mundial-particles-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'mundial-particles-root';
      root.setAttribute('aria-hidden', 'true');
    }

    root.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;' +
      'z-index:2147483646;pointer-events:none;overflow:hidden;';

    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    state.root = root;
    return root;
  }

  function createParticleEl(p) {
    var el = document.createElement('span');
    el.className = 'mp-particle';
    el.textContent = p.emoji;
    el.style.fontSize = p.size + 'px';
    el.style.opacity = '0.92';
    state.root.appendChild(el);
    p.el = el;
    return el;
  }

  function spawnParticle() {
    var size = 18 + Math.random() * 20;
    return {
      x: Math.random() * state.width,
      y: -size - Math.random() * state.height * 0.3,
      vx: (Math.random() - 0.5) * 0.6,
      vy: 0.5 + Math.random() * 0.9,
      size: size,
      emoji: pickEmoji(),
      rotation: Math.random() * 360,
      spin: (Math.random() - 0.5) * 2,
      sway: Math.random() * Math.PI * 2,
      swaySpeed: 0.008 + Math.random() * 0.012,
      el: null
    };
  }

  function fillParticles() {
    var limit = particleLimit();

    while (state.particles.length < limit) {
      var p = spawnParticle();
      p.y = Math.random() * state.height;
      createParticleEl(p);
      state.particles.push(p);
    }

    while (state.particles.length > limit) {
      var removed = state.particles.pop();
      if (removed && removed.el && removed.el.parentNode) {
        removed.el.parentNode.removeChild(removed.el);
      }
    }
  }

  function applyMouseForce(p, dt) {
    if (state.reducedMotion || !state.mouse.active) return;

    var dx = p.x - state.mouse.x;
    var dy = p.y - state.mouse.y;
    var distSq = dx * dx + dy * dy;
    var radius = 140;

    if (distSq < radius * radius && distSq > 1) {
      var dist = Math.sqrt(distSq);
      var force = (1 - dist / radius) * 2.8;
      p.vx += (dx / dist) * force * dt * 60;
      p.vy += (dy / dist) * force * dt * 60;
      p.rotation += force * 4 * (dx > 0 ? 1 : -1);
    }
  }

  function updateParticle(p, dt) {
    p.sway += p.swaySpeed;
    p.vx += Math.sin(p.sway) * 0.02;
    p.vy += 0.02 * dt * 60;
    p.vx *= 0.985;
    p.vy = Math.min(p.vy, 2.4);

    applyMouseForce(p, dt);

    p.x += p.vx * dt * 60;
    p.y += p.vy * dt * 60;
    p.rotation += p.spin;

    if (p.x < -40) p.x = state.width + 40;
    if (p.x > state.width + 40) p.x = -40;

    if (p.y > state.height + 60) {
      var fresh = spawnParticle();
      p.x = fresh.x;
      p.y = fresh.y;
      p.vx = fresh.vx;
      p.vy = fresh.vy;
      p.size = fresh.size;
      p.emoji = fresh.emoji;
      p.rotation = fresh.rotation;
      p.spin = fresh.spin;
      p.sway = fresh.sway;
      p.swaySpeed = fresh.swaySpeed;
      if (p.el) {
        p.el.textContent = p.emoji;
        p.el.style.fontSize = p.size + 'px';
      }
    }

    if (p.el) {
      p.el.style.transform =
        'translate3d(' + (p.x - p.size * 0.5) + 'px,' + (p.y - p.size * 0.5) + 'px,0) rotate(' + p.rotation + 'deg)';
    }
  }

  function tick(now) {
    if (!state.lastTime) state.lastTime = now;
    var dt = Math.min((now - state.lastTime) / 1000, 0.05);
    state.lastTime = now;

    for (var i = 0; i < state.particles.length; i++) {
      updateParticle(state.particles[i], dt);
    }

    state.rafId = requestAnimationFrame(tick);
  }

  function onMouseMove(e) {
    state.mouse.x = e.clientX;
    state.mouse.y = e.clientY;
    state.mouse.active = true;
  }

  function onMouseLeave() {
    state.mouse.active = false;
    state.mouse.x = -9999;
    state.mouse.y = -9999;
  }

  function onTouchMove(e) {
    if (!e.touches || !e.touches.length) return;
    state.mouse.x = e.touches[0].clientX;
    state.mouse.y = e.touches[0].clientY;
    state.mouse.active = true;
  }

  function onResize() {
    state.width = window.innerWidth;
    state.height = window.innerHeight;
    fillParticles();
    setStatus(state.running, null);
  }

  function stop() {
    if (state.rafId) cancelAnimationFrame(state.rafId);
    state.rafId = null;

    for (var i = 0; i < state.particles.length; i++) {
      if (state.particles[i].el && state.particles[i].el.parentNode) {
        state.particles[i].el.parentNode.removeChild(state.particles[i].el);
      }
    }
    state.particles = [];

    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseleave', onMouseLeave);
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onMouseLeave);
    window.removeEventListener('resize', onResize);

    setStatus(false, 'stopped');
  }

  function start(force) {
    if (state.running) return true;
    if (!document.body) {
      setStatus(false, 'no-body');
      return false;
    }

    state.reducedMotion = !force && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!ensureRoot()) {
      setStatus(false, 'no-root');
      return false;
    }

    state.width = window.innerWidth;
    state.height = window.innerHeight;
    fillParticles();

    if (!state.particles.length) {
      setStatus(false, 'no-particles');
      return false;
    }

    document.addEventListener('mousemove', onMouseMove, { passive: true });
    document.addEventListener('mouseleave', onMouseLeave);
    document.addEventListener('touchmove', onTouchMove, { passive: true });
    document.addEventListener('touchend', onMouseLeave, { passive: true });
    window.addEventListener('resize', onResize);

    setStatus(true, null);
    state.lastTime = 0;
    state.rafId = requestAnimationFrame(tick);
    return true;
  }

  function boot() {
    if (start()) {
      state.booted = true;
      return;
    }
    if (state.booted) return;

    [50, 150, 400, 1000, 2000].forEach(function (delay) {
      setTimeout(function () {
        if (!state.running) start();
      }, delay);
    });
  }

  window.MundialParticles = {
    start: function (force) { return start(!!force); },
    stop: stop,
    running: false,
    blockedReason: 'init',
    particleCount: 0
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();